type UnderliyingEnumType = string | number;

export abstract class EnumValueObject<T, U extends UnderliyingEnumType = string> {
  private readonly value: U;

  constructor(
    value: U,
    public readonly validValues: T[],
  ) {
    this.checkValueIsValid(value);
    this.value = value;
  }

  public checkValueIsValid(value: U): void {
    if (!this.validValues.includes(value as unknown as T)) {
      this.throwErrorForInvalidValue(value);
    }
  }

  public getValue(): T {
    return this.value as unknown as T;
  }

  public toString(): string {
    return String(this.value);
  }

  public equals(valueObject: EnumValueObject<T, U>): boolean {
    return this.value === valueObject.value;
  }

  protected abstract throwErrorForInvalidValue(value: U): void;
}
